import type { FC, FormEvent, ReactNode } from 'react'

import { useState } from 'react'

import { Seo, Layout } from '@/components/generals'
import { KitCards } from '@/components/landing/kit-cards'

const Home: FC = (): ReactNode => {
    const [subscribed, setSubscribed] = useState(false)

    const handleSubscribe = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault()
        setSubscribed(true)
    }

    return (
        <Layout>
            <Seo description='کیت کامل دستگاه CNC رومیزی با فریم، موتور، درایور، کنترلر، منبع تغذیه و سیم‌کشی. به‌صورت قطعات جدا یا مونتاژشده، ارسال از انبار تهران.' />

            {/* Hero */}
            <div className='section'>
                <div className='container no-paddings'>
                    <div className='hero-section'>
                        <div className='hero-section-text-holder'>
                            <div className='hero-section-sticky'>
                                <div className='hero-sticky-holder'>
                                    <div className='hero-text-holder'>
                                        <div className='hero-text-wrapper _01'>
                                            <div className='hero-text'>دستگاه CNC</div>
                                            <div className='hero-text-blur'>دستگاه CNC</div>
                                        </div>
                                        <div className='hero-text-wrapper _02'>
                                            <div className='hero-text _02'>رومیزی</div>
                                            <div className='hero-text-blur'>رومیزی</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='iphone-holder'>
                                <img src='/images/iPhone-14-Pro-–-Space-Black_1iPhone-14-Pro-–-Space-Black.webp' loading='eager' fetchPriority='high' sizes='(max-width: 800px) 100vw, 800px' srcSet='/images/iPhone-14-Pro-–-Space-Black_1-p-500.png 500w, /images/iPhone-14-Pro-–-Space-Black_1iPhone-14-Pro-–-Space-Black.webp 800w' alt='' className='iphone-image-home-page' />
                                <div className='iphone-screen'>
                                    <img src='/images/Hero-Iphone-Image_1Hero-Iphone-Image.webp' loading='eager' fetchPriority='high' alt='' sizes='(max-width: 479px) 80vw, 267.875px' srcSet='/images/Hero-Iphone-Image_1-p-500.jpg 500w, /images/Hero-Iphone-Image_1Hero-Iphone-Image.webp 729w' className='iphone-screen-image' />
                                </div>
                                <div className='iphone-drop-shadow' />
                            </div>
                        </div>
                        <div className='hero-section-paragraph-holder'>
                            <div className='hero-paragraph-holder'>
                                <p>کیت کامل دستگاه CNC رومیزی با فریم، موتور، درایور، کنترلر، منبع تغذیه و سیم‌کشی. به‌صورت قطعات جدا یا مونتاژشده، ارسال از انبار تهران.</p>
                            </div>
                            <div className='from-wrapper'>
                                <div className='form-block w-form'>
                                    <form onSubmit={handleSubscribe} style={{ display: subscribed ? 'none' : undefined }} className='subscribe-form'>
                                        <div className='from-holder'>
                                            <input className='text-field-form w-input' maxLength={256} name='email' placeholder='ایمیل شما' aria-label='ایمیل شما' type='email' required />
                                            <input type='submit' className='button from w-button' value='خبرم کن' />
                                        </div>
                                    </form>
                                    <div className='success-message w-form-done' style={{ display: subscribed ? 'block' : 'none' }}>
                                        <div>ممنون! از موجودی و قیمت‌های جدید باخبرتان می‌کنیم.</div>
                                    </div>
                                    <div className='error-message w-form-fail'>
                                        <div>متأسفانه مشکلی پیش آمد. لطفاً دوباره تلاش کنید.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='logo-grid-holder'>
                        <div className='w-layout-grid logo-grid'>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcd8-d9af3b6e' className='logo-small-container'><img src='/images/Logo01.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcda-d9af3b6e' className='logo-small-container'><img src='/images/Logo02.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcdc-d9af3b6e' className='logo-small-container'><img src='/images/Logo03.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcde-d9af3b6e' className='logo-small-container'><img src='/images/Logo04.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce0-d9af3b6e' className='logo-small-container'><img src='/images/Logo05.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce2-d9af3b6e' className='logo-small-container'><img src='/images/Logo06.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce4-d9af3b6e' className='logo-small-container'><img src='/images/Logo07.svg' loading='lazy' alt='' className='logo-small' /></div>
                            <div id='w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce6-d9af3b6e' className='logo-small-container'><img src='/images/Logo08.svg' loading='lazy' alt='' className='logo-small' /></div>
                        </div>
                        <div className='fade-in-move-on-scroll'>
                            <p>ساخته‌شده بر پایهٔ طرح‌های متن‌باز OpenBuilds</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Experience */}
            <div id='experince' className='section'>
                <div className='container'>
                    <div className='experience-section'>
                        <div className='center-title'>
                            <div className='title-holder'>
                                <h1 className='title'>از کیت قطعات تا دستگاه آمادهٔ کار.</h1>
                            </div>
                        </div>
                        <div className='experience-cards-holder'>
                            <div className='experience-grid'>
                                <div id='w-node-_1261dedf-b3c9-2162-53e7-29ae1d8c7955-d9af3b6e' className='experience-wrapper'>
                                    <div id='w-node-c9a3eb7f-e26e-bb52-e19d-39f848eddb94-d9af3b6e' className='experience-card'>
                                        <div className='light-wrapper-in-front'>
                                            <div className='light'><div className='light-outside' /></div>
                                        </div>
                                        <div className='experience-card-content'>
                                            <div className='experience-card-image-holder'>
                                                <img src='/images/Card-Image-2_1Card-Image-2.webp' loading='lazy' alt='' className='experience-card-image' />
                                                <div className='experience-gradient' />
                                            </div>
                                            <div className='experience-card-text-holder'>
                                                <div className='card-title'>کیت کامل، بدون قطعهٔ جاافتاده</div>
                                                <div className='experience-paragraph-holder'>
                                                    <p>فریم، حرکت با لیدسکرو، الکترونیک NEMA 23 با کنترلر MKS DLC32 و سیم‌کشی، همه داخل کیت است.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='light-wrapper'>
                                            <div className='light'><div className='light-inside' /></div>
                                        </div>
                                    </div>
                                </div>
                                <div id='w-node-_8c828c4b-063f-f20f-6482-b138be2c6dbe-d9af3b6e' className='experience-wrapper'>
                                    <div id='w-node-_7c769986-af35-2c7e-a088-51a92c6e6099-d9af3b6e' className='experience-card'>
                                        <div className='light-wrapper-in-front'>
                                            <div className='light'><div className='light-outside' /></div>
                                        </div>
                                        <div className='experience-card-content'>
                                            <div className='experience-card-image-holder _02'>
                                                <img src='/images/Level_1Level.webp' loading='lazy' alt='' className='experience-card-image' />
                                                <div className='experience-gradient' />
                                            </div>
                                            <div className='experience-card-text-holder _02'>
                                                <div className='card-title'>سه دستگاه، سه اندازهٔ کار</div>
                                                <div className='experience-paragraph-holder'>
                                                    <p>MiniMill، C-Beam Machine و C-Beam XLarge، از قطعات کوچک تا ورق‌های بلند.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='light-wrapper'>
                                            <div className='light'><div className='light-inside' /></div>
                                        </div>
                                    </div>
                                </div>
                                <div id='w-node-_7c369291-b38e-0008-5e70-efcc18461d4c-d9af3b6e' className='experience-wrapper'>
                                    <div id='w-node-_7c369291-b38e-0008-5e70-efcc18461d4d-d9af3b6e' className='experience-card'>
                                        <div className='light-wrapper-in-front'>
                                            <div className='light'><div className='light-outside' /></div>
                                        </div>
                                        <div className='experience-card-content'>
                                            <div className='experience-card-image-holder smaller'>
                                                <img src='/images/Level-02_1Level-02.webp' loading='lazy' alt='' className='experience-card-image' />
                                                <div className='experience-gradient _02' />
                                            </div>
                                            <div className='experience-card-text-holder _02'>
                                                <div className='card-title'>مونتاژ اختیاری</div>
                                                <div className='experience-paragraph-holder'>
                                                    <p>کیت را خودتان ببندید یا دستگاه را مونتاژشده تحویل بگیرید.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='light-wrapper'>
                                            <div className='light'><div className='light-inside' /></div>
                                        </div>
                                    </div>
                                </div>
                                <div id='w-node-_7a405be8-0a26-057e-3bd3-7289f3f9886f-d9af3b6e' className='experience-wrapper'>
                                    <div id='w-node-_7a405be8-0a26-057e-3bd3-7289f3f98870-d9af3b6e' className='experience-card'>
                                        <div className='light-wrapper-in-front'>
                                            <div className='light'><div className='light-outside' /></div>
                                        </div>
                                        <div className='experience-card-content'>
                                            <div className='experience-card-text-holder padding'>
                                                <div className='card-title'>اسپیندل یا تریمر، به انتخاب شما</div>
                                                <div className='experience-paragraph-holder'>
                                                    <p>اسپیندل همراه کیت نیست. در صورت درخواست، اسپیندل یا تریمر به سفارش شما اضافه می‌شود.</p>
                                                </div>
                                            </div>
                                            <div className='experience-card-image-holder'>
                                                <img src='/images/Visitor-Insights-02_1Visitor-Insights-02.webp' loading='lazy' alt='' className='experience-card-image' />
                                            </div>
                                        </div>
                                        <div className='light-wrapper'>
                                            <div className='light'><div className='light-inside' /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Integration */}
            <div id='integration' className='section'>
                <div className='effortlessly-integration-section'>
                    <div className='container'>
                        <div className='effortlessly-integration-container'>
                            <div className='center-title'>
                                <div className='title-holder'>
                                    <div className='fade-in-move-on-scroll'>
                                        <h1 className='title'>قطعه‌ها، جدا هم فروخته می‌شوند</h1>
                                    </div>
                                    <div className='fade-in-move-on-scroll'>
                                        <div className='experience-paragraph-holder'>
                                            <p>پروفیل شیاردار، V-Slot، موتور، درایور و کنترلر را جداگانه بخرید و دستگاه خودتان را طراحی کنید.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='effortlessly-integration-wrapper'>
                        <div className='iphone-holder-effortlessly-integration'>
                            <div className='effortlessly-integration---iphone-holder'>
                                <img src='/images/iPhone-14-Pro-–-Space-Black_1iPhone-14-Pro-–-Space-Black.webp' loading='eager' sizes='(max-width: 800px) 100vw, 800px' srcSet='/images/iPhone-14-Pro-–-Space-Black_1-p-500.png 500w, /images/iPhone-14-Pro-–-Space-Black_1iPhone-14-Pro-–-Space-Black.webp 800w' alt='' className='iphone-image' />
                                <div className='iphone-screen'>
                                    <img src='/images/Hero-Iphone-Image_1Hero-Iphone-Image.webp' loading='eager' alt='' sizes='390.453125px' srcSet='/images/Hero-Iphone-Image_1-p-500.jpg 500w, /images/Hero-Iphone-Image_1Hero-Iphone-Image.webp 729w' className='iphone-screen-image' />
                                </div>
                                <div className='iphone-drop-shadow low' />
                            </div>
                        </div>
                        <div className='logo-holder-effortlessly-integration'>
                            <div className='logo-holder'><img src='/images/Logo-01.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-01.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                            <div className='logo-holder'><img src='/images/Logo-02.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-02.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                            <div className='logo-holder'><img src='/images/Logo-04.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-04.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                            <div className='logo-holder'><img src='/images/Logo-03.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-03.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                            <div className='logo-holder'><img src='/images/Logo-05.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-05.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                            <div className='logo-holder'><img src='/images/Logo-01.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-01.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                            <div className='logo-holder'><img src='/images/Logo-06.svg' loading='lazy' alt='' className='logo-image' /><img src='/images/Logo-06.svg' loading='lazy' alt='' className='logo-image blured' /></div>
                        </div>
                        <div className='light-holder' />
                        <div className='workflow-section'>
                            <div className='fade-in-move-on-scroll'>
                                <div className='card-title'>سازگار با استاندارد OpenBuilds</div>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='experience-paragraph-holder'>
                                    <p>صفحه‌ها، چرخ‌های V و اتصالات استاندارد OpenBuilds با پروفیل‌های V-Slot و C-Beam جفت می‌شوند، پس دستگاهتان را هر وقت خواستید بزرگ‌تر کنید.</p>
                                </div>
                            </div>
                            <div className='line' />
                        </div>
                    </div>
                </div>
            </div>

            {/* Warranty and service */}
            <div id='features' className='section'>
                <div className='sticky-section'>
                    <div className='container wide-container'>
                        <div className='w-layout-grid grid-6-col'>
                            <div id='w-node-_0f99c55c-aef0-ebd9-f690-9830ff12bd17-d9af3b6e' className='trusted-content'>
                                <div className='content-sticky'>
                                    <div className='fade-in-on-scroll'>
                                        <h1 className='title smaller'>پیش از خرید، بدانید چه می‌گیرید</h1>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <p>ضمانت، خدمات پس از فروش و زمان آماده‌سازی هر سفارش را شفاف اعلام می‌کنیم تا با خیال راحت خرید کنید.</p>
                                    </div>
                                </div>
                            </div>
                            <div id='w-node-_0f99c55c-aef0-ebd9-f690-9830ff12bd1f-d9af3b6e' className='trusted-content trusted-list'>
                                <div className='trusted-overlay-container'>
                                    <div className='trusted-white-overlay' />
                                    <div className='trusted-white-overlay bottom' />
                                </div>
                                <div className='trusted-item'>
                                    <div className='trusted-item-header'>
                                        <h2 className='trusted-no'>۱</h2>
                                        <div className='card-title'><strong>سال ضمانت کتبی قطعات مکانیکی</strong></div>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <p>پروفیل، صفحه‌ها، لیدسکرو، چرخ‌ها و اتصالات یک سال ضمانت کتبی دارند.</p>
                                    </div>
                                </div>
                                <div className='trusted-item'>
                                    <div className='trusted-item-header'>
                                        <h2 className='trusted-no'>۵</h2>
                                        <div className='card-title'><strong>سال خدمات پس از فروش</strong></div>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <p>برای هر دستگاهی که از ما خریده‌اید، تا پنج سال خدمات پس از فروش ارائه می‌دهیم.</p>
                                    </div>
                                </div>
                                <div className='trusted-item'>
                                    <div className='trusted-item-header'>
                                        <h2 className='trusted-no'>۲</h2>
                                        <div className='card-title'><strong>سال تأمین قطعات الکترونیک</strong></div>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <p>قطعهٔ یدکی موتور، درایور، کنترلر و منبع تغذیه (همان قطعه یا معادل آن) تا دو سال تأمین می‌شود. این قطعات ضمانت ندارند و فقط سالم بودنشان هنگام تحویل تضمین می‌شود.</p>
                                    </div>
                                </div>
                                <div className='trusted-item last'>
                                    <div className='trusted-item-header'>
                                        <h2 className='trusted-no'>۴</h2>
                                        <div className='card-title'><strong>روز کاری، حداکثر زمان آماده‌سازی</strong></div>
                                    </div>
                                    <div className='fade-in-on-scroll'>
                                        <p>سفارش‌های عادی در ۱ تا ۲ روز کاری و سفارش‌های دارای برش یا کار اضافه معمولاً در ۱ تا ۴ روز کاری آماده می‌شوند.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact */}
            <div id='download' className='section'>
                <div className='container'>
                    <div className='effortlessly-integration-container'>
                        <div className='center-title'>
                            <div className='title-holder'>
                                <div className='fade-in-move-on-scroll'>
                                    <h1 className='title'>از انبار تهران، تا کارگاه شما</h1>
                                </div>
                                <div className='fade-in-move-on-scroll'>
                                    <div className='experience-paragraph-holder'>
                                        <p>سفارش‌ها با تیپاکس، باربری یا پیک ارسال می‌شوند. برای مشاورهٔ پیش از خرید تماس بگیرید یا در واتس‌اپ پیام بدهید.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='download-badge-holder'>
                            <div className='download-badge-container'>
                                <a href='tel:09981414040' className='button w-button'>تماس: ۰۹۹۸۱۴۱۴۰۴۰</a>
                                <a href='https://wa.me/989981414040' target='_blank' rel='noreferrer' className='button w-button'>پیام در واتس‌اپ</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dark-and-light-mode-holder'>
                    <div className='dark-and-light-mode-container'>
                        <div className='dark-and-light-mode-sticky'>
                            <div className='dark-mode-holder'>
                                <div className='center-iphone'>
                                    <div className='dark-mode-hand-holder'>
                                        <img src='/images/Iphone-In-Hand_1Iphone-In-Hand.webp' loading='eager' sizes='(max-width: 848px) 100vw, 848px' srcSet='/images/Iphone-In-Hand_1-p-500.png 500w, /images/Iphone-In-Hand_1-p-800.png 800w, /images/Iphone-In-Hand_1Iphone-In-Hand.webp 848w' alt='' className='dark-mode-hand' />
                                        <div className='dark-mode-app-holder'>
                                            <img src='/images/Dark-Mode_1Dark-Mode.webp' loading='eager' alt='' sizes='232px' srcSet='/images/Dark-Mode_1-p-500.jpg 500w, /images/Dark-Mode_1-p-800.jpg 800w, /images/Dark-Mode_1Dark-Mode.webp 1035w' className='dark-mode-app' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='white-mode-holder'>
                                <div className='center-iphone'>
                                    <div className='dark-mode-hand-holder'>
                                        <img src='/images/Iphone-In-Hand_1Iphone-In-Hand.webp' loading='eager' sizes='(max-width: 848px) 100vw, 848px' srcSet='/images/Iphone-In-Hand_1-p-500.png 500w, /images/Iphone-In-Hand_1-p-800.png 800w, /images/Iphone-In-Hand_1Iphone-In-Hand.webp 848w' alt='' className='dark-mode-hand' />
                                        <div className='dark-mode-app-holder'>
                                            <img src='/images/Light-Mode_1Light-Mode.webp' loading='eager' alt='' sizes='232px' srcSet='/images/Light-Mode_1-p-500.jpg 500w, /images/Light-Mode_1-p-800.jpg 800w, /images/Light-Mode_1Light-Mode.webp 1036w' className='dark-mode-app' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <KitCards />
        </Layout>
    )
}

export default Home
